import { Add as AddIcon, Check as CheckIcon } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../common/components/styled/styled";
import { ShiftOrderContext } from "./newOrder/short/OrderShortDataProvider";
import OverlappingOrderRowsError from "./OverlappingOrderRowsError";
import { OrderRow } from "./orderTypes";

type Props = {
  isEditing: boolean;
  row: OrderRow;
  bundleRowId: string;
  bundleButtonDisabled: boolean;
  handleEditingCompleted: () => void;
};

const OrderBundleActionRow = ({
  isEditing,
  bundleRowId,
  bundleButtonDisabled,
  handleEditingCompleted,
  row,
}: Props) => {
  const { t } = useTranslation(["common, order"]);
  const { handleAddNewRowToBundle, validationErrors } =
    useContext(ShiftOrderContext);

  return (
    <Box
      sx={{
        padding: "8px 0px",
        position: "relative",
        display: "flex",
      }}
    >
      {isEditing && (
        <>
          <Button
            onClick={() => handleAddNewRowToBundle(bundleRowId)}
            startIcon={<AddIcon />}
            variant="outlined"
            sx={{
              borderRadius: "20px",
              marginRight: "0.5rem",
            }}
          >
            {t("common:shift")}
          </Button>
          <RoundedButton
            disabled={bundleButtonDisabled}
            startIcon={<CheckIcon />}
            variant="contained"
            onClick={handleEditingCompleted}
          >
            {t("common:complete")}
          </RoundedButton>
        </>
      )}
      <OverlappingOrderRowsError
        row={row}
        validationErrors={validationErrors}
        position={{ left: isEditing ? "860px" : "820px", bottom: "8px" }}
      />
    </Box>
  );
};

export default OrderBundleActionRow;
